import memoize from 'js/lib/memoize';

import courseViewGradeDataPromise from 'pages/open-course/common/data/courseViewGrade';
import CourseViewGrade from 'pages/open-course/common/models/courseViewGrade';

const courseViewGradePromise = (id: $TSFixMe, rawData: $TSFixMe) => {
  return courseViewGradeDataPromise(id).then((courseViewGradeData) => {
    if (rawData) {
      return courseViewGradeData;
    }

    return courseViewGradeData && new CourseViewGrade(courseViewGradeData);
  });
};

export default courseViewGradePromise;
export const memoizedCourseViewGradePromise = memoize(courseViewGradePromise);
